import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0e0dbb91"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "page"
};
const _hoisted_2 = {
  key: 0,
  class: "nav-margin"
};
const _hoisted_3 = {
  class: "foot"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  const _component_van_sticky = _resolveComponent("van-sticky");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("header", null, [_createVNode(_component_van_sticky, null, {
    default: _withCtx(() => [_createVNode(_component_van_nav_bar, {
      title: $data.pageTitle
    }, null, 8, ["title"])]),
    _: 1
  }), _renderSlot(_ctx.$slots, "header", {}, undefined, true)]), _createElementVNode("main", null, [$props.showNavMargin != undefined ? (_openBlock(), _createElementBlock("div", _hoisted_2)) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default", {}, undefined, true)]), _createElementVNode("footer", _hoisted_3, [_renderSlot(_ctx.$slots, "footer", {}, undefined, true)])]);
}